import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-cabecalho-esquerda',
  templateUrl: './cabecalho-esquerda.component.html',
  styleUrls: ['./cabecalho-esquerda.component.scss']
})

export class CabecalhoEsquerdaComponent implements OnInit {
  @Input() data;
 
  constructor() {
  }

  ngOnInit() {
  }
}
